export default "__VITE_ASSET__CUx8Dukp__"